import { rem, theme } from '@nobia/zeus-components/lib/styled'

export default {
  base: {
    backgroundColor: '#fff',
    fontSize: 16,
    lineHeight: 23,
    fontWeight: 300,
    letterSpacing: 'normal',
    borderRadius: rem(6),
  },
  horizontalScrollable: {
    fade: {
      linearGradientLeft: `linear-gradient(
        to left,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.9) 90%,
        white 100%
      )`,
      linearGradientRight: `linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.3) 20%,
        rgba(255, 255, 255, 0.9) 60%,
        white 100%
      )`,
    },
    arrow: {
      linearGradientLeft: `linear-gradient(
        to left,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.1) 50%,
        rgba(255, 255, 255, 0.2) 60%,
        rgba(255, 255, 255, 0.5) 80%,
        white 100%
      )`,
      linearGradientRight: `linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.1) 10%,
        rgba(255, 255, 255, 0.3) 20%,
        white 85%
      )`,
    },
  },
  colors: {
    textColor: '#001c33',
    darkBlue: '#001c33',
    lighterBlue: '#dfe6f6',
    lightBlue: '#5f7ed2',
    lightBlueTransparent: '#5f7ed244',
    gold: '#DFC6B3',
  },
  navigation: {
    wrapper: {
      background: '#fff',
      border: '1px solid #eee',
      lg: {
        width: rem(166),
      },
    },
    item: {
      color: theme('colors.primary'),
      activeColor: theme('colors.primary'),
      activeBackgroundColor: theme('colors.lightBlueTransparent'),
    },
  },
  tabs: {
    background: '#dfe6f6',
    color: theme('colors.primary'),
    backgroundColor: '#e9edf9',
    activeColor: theme('colors.primary'),
    activeBackgroundColor: theme('colors.white'),
  },
  typography: {
    paragraph: {
      color: '#001c33',
      fontWeight: 300,
    },
    link: {
      color: '#5f7ed2',
      fontWeight: 500,
    },
  },
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  },
  header: {
    logo: {
      margin: rem(20),
    },
  },
  checkbox: {
    size: 24,
  },
  step: {
    background: '#ffffffee',
    margins: '0 0 20px 0',
    border: rem(6),
    checkedStep: {
      border: '2px solid #00000000',
    },
    uncheckedStep: {
      border: '2px solid #00000000',
    },
  },
  multiStorePage: {
    background: '#f4f2f0',
    alignItems: 'left',
    maxWidth: rem(1280),
    storeSelector: {
      background: '#fff',
      border: '1px solid #ddd',
      borderRadius: rem(6),
    },
  },
  overlayBada: {
    icon: {
      top: rem(15),
      md: {
        top: rem(25),
      },
    },
  },
}
